module.exports = __webpack_public_path__ + "static/slide4-b2e50fb94ab8eb7d34277010587bed6f.jpg";